/** @format */

import menuRoutes from "@model/menu-routes.js";
import crocoDeskRoutes from "@model/croco-desk-routes.js";

// 「戻る」ルートがある場合はリロード
window.addEventListener("popstate", () => {
  const url = new URL(location.href);
  if (menuRoutes.pages.find((v) => v.route.exec(url.pathname))) {
    location.reload();
  }
  if (crocoDeskRoutes.pages.find((v) => v.route.exec(url.pathname))) {
    location.reload();
  }

});
